import React from 'react';
import classNames from 'classnames';

const InputText = ({ label, value, isMandatory, onUpdate, name, ph, lblClassName, inputClassName, extraContClass, validateFn }) => {
  const contClasses = classNames({
    'kfpr-input': true,
    [extraContClass]: true,
    'kf-invalid': typeof validateFn === 'function' ? !validateFn(value) : false,
    'kf-valid': typeof validateFn === 'function' ? validateFn(value) : false,
    'kf-filled': value && value.length > 0,
    'kf-unfilled': !value || value.length === 0
  });

  return (
    <div className={contClasses}>
        <label>
            {
              isMandatory && 
              <span className={lblClassName || "kf-orange-txt"}>*</span>
            }
            {label}
        </label>
        <input 
          placeholder={ph || ""}
          type="text" 
          value={value} 
          name={name || ""}
          className={inputClassName || ""}
          aria-required="true" 
          aria-invalid="false" 
          onChange={onUpdate} /> 
    </div>       
  );
}

export default InputText;
